
import { Button, Grid, Link, Paper, Typography } from "@material-ui/core";
import FormatService from "services/formatService";
import { vehiclePaveListStyle } from "./style";
import { paveCheckinStatusLabel } from "features/Reservation/reservationConsts";
import LaunchIcon from '@material-ui/icons/Launch';

const PaveItem = ({ item, onSelect }) => {
    const classes = vehiclePaveListStyle();


    /*PAVE Date 01/25/2025
PAVE Report Status  Completed
PAVE Repair $625.00
PAVE Points of Damage  1
PAVE Repair/Damage  Passed*/
    return (
        <Grid container direction="column" spacing={1} className={classes.container}>
            <Grid item container justifyContent="space-between" className={classes.titleWrapper} >
                <Grid item className={classes.title}>PAVE Inspection</Grid>
                <Grid item >
                    {/* <Link className={classes.link} target='_blank' href={item?.paveResultsUrl}>View Results</Link> */}
                    <Button variant="text" className={classes.link} onClick={onSelect}>View Results</Button>
                </Grid>
            </Grid>
            <Grid container item className={classes.textWrapper}>
                <div className={classes.label}>Date:</div>
                <div className={classes.value}>{item?.completedDate ? FormatService.formatDate(item?.completedDate) : '-'}</div>
            </Grid>
            <Grid container item className={classes.textWrapper}>
                <div className={classes.label}>Report Status:</div>
                <div className={classes.value}>{paveCheckinStatusLabel[item.status]}</div>
            </Grid>
            <Grid container item className={classes.textWrapper}>
                <div className={classes.label}>Repair:</div>
                <div className={classes.value}>{FormatService.formatCurrency(item?.damageTotalCost)}</div>
            </Grid>
            <Grid container item className={classes.textWrapper}>
                <div className={classes.label}>Points of Damage:</div>
                <div className={classes.value} >{item?.damageCount}</div>
            </Grid>
        </Grid>
    )
}

export default PaveItem;